import React from 'react';
import { graphql } from 'gatsby';

import { CategoryLayout } from './layouts';

import { Layout } from '../layouts/Main';

import { 
    Header, 
    Footer, 
} from '../components';

const CategoryTemplate = (props) => {
    console.log(props.pageContext.id);
    return (
        <Layout>
            <Header />
            <CategoryLayout {...props}/>
            <Footer />
        </Layout>
    )
}
    
export default CategoryTemplate;

export const pageQuery = graphql`  
query CategoriesTemplateQuery($id: String!, $name: String!, $date: String!, $limit: Int!, $start: Int!) {
    mb {
        posts: blogposts(where: {
                categories: {
                    Name: $name
                },
                publish_date_lte: $date,
                status: "published"
            }, sort: "publish_date:desc", limit: $limit, start: $start) {
            id
            title
            content
            title_icon {
                url
            }
            preview{
                url
            }
            slug
        }
        subcategories: subcategories(where: {category: $id}, sort:"index:asc") {
            name
            index
            link
            blogposts(sort:"publish_date:asc"){
                id
                title
                slug
                publish_date
            }
        }
        menu_categories: categories(where: {in_browse_resources: true}, sort:"index:asc"){
            id
            Name
            index
            link
            external_link
        }
    }
}
`;
